import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ["show", "pending", "following", "done"]

  connect() {}

  toggle() {
    this.showTarget.classList.toggle("hidden")
  }

  show_message_checkbox() {
    document.getElementsByName("message-checkbox").forEach((e) => {
      e.classList.remove("hidden")
    })
  }

  hide_message_checkbox() {
    document.getElementsByName("message-checkbox").forEach((e) => {
      e.classList.add("hidden")
      e.checked = false
    })
  }

  store_message_ids(e) {
    String.prototype.splitPlus = function (sep) {
      var a = this.split(sep)
      if (a[0] == "" && a.length == 1) return []
      return a
    }
    const seleced_message_ids = document.getElementById("seleced_message_ids").value.splitPlus(",")
    this._addOrRemove(seleced_message_ids, e.target.value)
    document.getElementById("seleced_message_ids").value = seleced_message_ids.join(",")
  }

  _addOrRemove(array, value) {
    var index = array.indexOf(value)
    if (index === -1) {
      array.push(value)
    } else {
      array.splice(index, 1)
    }
  }

  switch_reply_user(e) {
    const room_id = document.getElementById("room_id").value
    Rails.ajax({
      type: "POST",
      url: `/rooms/${room_id}/switch_reply_user`,
      data: new URLSearchParams({ reply_user: e.target.value }).toString(),
      success: function (response) {
        console.log(response)
      },
      error: function (err) {
        console.error(err)
      },
    })
  }
}
